import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePermissions, PAGE_PERMISSION_IDS } from '../hooks/usePermissions';

/** Маппинг path → permission id */
const ROUTE_PERMISSIONS = {
  '/': PAGE_PERMISSION_IDS.dashboard,
  '/hr-schedule': PAGE_PERMISSION_IDS.hr,
  '/construction-schedule': PAGE_PERMISSION_IDS.construction,
  '/procurement-schedule': PAGE_PERMISSION_IDS.procurement,
  '/marketing-schedule': PAGE_PERMISSION_IDS.marketing,
  '/preconstruction-schedule': PAGE_PERMISSION_IDS.preconstruction,
  '/directive-schedule': PAGE_PERMISSION_IDS.directive,
  '/project-office': PAGE_PERMISSION_IDS.project_office,
  '/strategic-map': PAGE_PERMISSION_IDS.strategic_map,
  '/cities': PAGE_PERMISSION_IDS.cities,
  '/construction-stages': PAGE_PERMISSION_IDS.stages,
  '/process-management': PAGE_PERMISSION_IDS.process,
  '/dependency-manager': PAGE_PERMISSION_IDS.dependencies,
  '/feedback': PAGE_PERMISSION_IDS.feedback,
};

/**
 * Обёртка Layout: проверяет права на текущий маршрут и редиректит при отсутствии доступа.
 * Telegram и admin защищены отдельно (admin-only).
 */
export default function PermissionRoute({ children }) {
  const location = useLocation();
  const { canView, isAdmin } = usePermissions();
  const path = location.pathname;
  const permId = ROUTE_PERMISSIONS[path];

  if (path === '/telegram-settings' || path === '/admin') {
    if (!isAdmin) return <Navigate to="/" replace />;
    return children;
  }

  if (!permId) return children;
  if (isAdmin) return children;
  if (canView(permId)) return children;

  return <Navigate to="/" replace />;
}
